import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';

const ToolsComponent = ({limit}) => {
  const [tools, setTools] = useState([]);
   
  const getAllHackingTools = async () => {
    try {
      const data = new FormData();
      if(limit){
        data.append('limit', limit);
      }
      const response = await axios.post(ENDPOINT+'get-hacking-tools.php', data, SecurityHeaders);
      if(response) {
        if(response.data.status === "success") {
          setTools(response.data.data);
        }
      } else {
        console.error('Failed to fetch hacking tools');
      }
    } catch(error) {
      console.error('Error fetching hacking tools:', error);
    }
  }

  useEffect(() => {
    getAllHackingTools();
  }, []);

  return (
    <div className="">
      <div className="d-flex flex-wrap text-white animate-fade animation-active">
        {tools.map((tool, index) => (
          <Link 
            key={tool.id} 
            to={'/tool-details/'+tool.id} 
            className={"col-lg-3 col-6 p-2 fade-in-bottom delay"+index+"s"}
          >
            <div className="shadow text-center rounded theme-border border bg-transparent bg-transparent">
              <img src={tool.image} className="w-100 rounded-top rounded-bottom-0" alt={tool.title} />
              <div className="p-3">
                <h4 className='fw-bold text-responsive'>{tool.title}</h4>
                <p className="truncate truncate3 text-responsive">{tool.description}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Responsive Text Color: Auto-adjusts to background */}
      <style jsx>{`
        .text-responsive {
          color: white;
          -webkit-text-stroke: 0.5px black;
          text-stroke: 0.5px black;
        }

        /* Light background (default or light mode) */
        .bg-light .text-responsive,
        .bg-white .text-responsive,
        .bg-transparent .text-responsive {
          color: black;
          -webkit-text-stroke: 0.5px white;
          text-stroke: 0.5px white;
        }

        /* Dark mode (system preference) */
        @media (prefers-color-scheme: dark) {
          .text-responsive {
            color: white;
            -webkit-text-stroke: 0.5px black;
            text-stroke: 0.5px black;
          }
        }

        /* Force light text on dark backgrounds */
        .bg-dark .text-responsive,
        .bg-secondary .text-responsive,
        .bg-primary .text-responsive {
          color: white;
          -webkit-text-stroke: 0.5px black;
        }

        /* Force dark text on light backgrounds */
        .bg-light .text-responsive,
        .bg-white .text-responsive {
          color: black;
          -webkit-text-stroke: 0.9px white;
        }
      `}</style>
    </div>
  )
}

export default ToolsComponent